<template>
  <div>
    <HeroVue></HeroVue>
    <AboutVue></AboutVue>
    <SkilsVue></SkilsVue>
    <ServicesVue></ServicesVue>
    <TestimonialVue></TestimonialVue>
  </div>
</template>

<script>
  import HeroVue from './sections/HeroVue.vue';
import AboutVue from './sections/AboutVue.vue';
import SkilsVue from './sections/SkilsVue.vue';
import ServicesVue from './sections/ServicesVue.vue';
import TestimonialVue from './sections/TestimonialVue.vue';
export default {
  components:{
    HeroVue,
    AboutVue,
    SkilsVue,
    ServicesVue,
    TestimonialVue
}
}
</script>